import m from "../../geodata/es2015/angolaHigh";
window.am4geodata_angolaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/angolaHigh.js
// module id = null
// module chunks = 